import { getMetaTag } from "../results/selectors";

export const metaTagMiddleware = () => store => next => action => {
  
  next(action);
  if(action.meta && action.meta.updateMetaTag){    
    const state = store.getState();
    const metaTag = getMetaTag(state);
    if(metaTag) document.querySelector('meta[name="description"]').setAttribute('content', metaTag)
  }
}